<!-- DEBUG: Holiday notification component rendered -->
<!-- DEBUG: visible = {{ visible }}, title = {{ title }} -->

<div *ngIf="visible" class="holiday-banner">
  <div class="banner-content">
    <div class="banner-text">
      <h2 class="banner-title">{{ title }}</h2>
      <p class="banner-message">{{ message }}</p>
    </div>
    <div class="banner-actions">
      <button mat-raised-button color="primary" class="thank-you-btn" (click)="onClose()">
        <mat-icon>music_note</mat-icon>
        Keep Dancing!
      </button>
      <button mat-icon-button class="close-btn" (click)="onClose()" aria-label="Close Memorial Day message">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  </div>

  <!-- Animated dance decorations -->
  <div class="dance-elements">
    <div class="dance-note note-1">♪</div>
    <div class="dance-note note-2">♫</div>
    <div class="dance-note note-3">♪</div>
    <div class="dance-note note-4">♫</div>
    <div class="dancer dancer-1">💃</div>
    <div class="dancer dancer-2">🕺</div>
  </div>
</div>
